import { Theme } from '@mui/material';

export default {
    field: {
        '&.multiple': {
            display: 'flex',
            alignItems: 'center',

            '&:not(:last-of-type)': {
                marginBottom: '10px',
            },

            '& > svg': {
                marginLeft: '8px',
                cursor: 'pointer',
                color: (theme: Theme) => theme.palette.primary.main,
            },
        },
    },
    timeField: {
        display: 'flex',
        alignItems: 'center',
    },
    separator: {
        margin: '0 5px',
    },
    selectBox: {
        width: '100px',

        '&.multiple': {
            width: '117px',
        },
    },
};
